import React, {PureComponent} from "react"

import {Select} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {officesForTenant} from "@irati/identity/utils/tenant/hasMultipleOffices"
import teamName from "@irati/identity/utils/team/teamName"

interface State {
  isLoading: boolean,
  options: any[]
}

interface Props extends InjectIntl {
  value: string,
  onChange: (value: string) => void,
  validation?: () => any
}

class Office extends PureComponent<Props, State> {
  state: State = {
    isLoading: true,
    options: []
  }

  componentDidMount() {
    return officesForTenant().then((offices) => {
      const options = offices.map((team) => {
        return {
          label: teamName(team),
          value: team.uuid
        }
      })
      this.setState({isLoading: false, options})
    })
  }

  buildOfficeSchema = () => {
    return Validation.string("platform.defaultValidation.required")
  }

  render() {
    const {validation, formatMessage, ...props} = this.props
    const {options, isLoading} = this.state

    return (
      <Select
        name="user.locale"
        label={formatMessage({id: "platform.fields.country.label"})}
        options={options}
        isClearable={false}
        isLoading={isLoading}
        {...props}
        validation={validation || this.buildOfficeSchema()} />
    )
  }
}

export default injectIntl(Office)
